import { snackbarService } from '@/design/core/composables/useSnackbar'
import { inject } from 'vue'

export default {
  install(app) {
    app.config.globalProperties.$snackbar = function (info) {
      snackbarService.show(info)
    }
    app.provide('$snackbar', app.config.globalProperties.$snackbar)
  },
}

export function useSnackbar() {
  const $snackbar = inject('$snackbar')
  if (!$snackbar) {
    throw new Error('Plugin snackbar not found')
  }
  return $snackbar
}
